import React from 'react';
import { useToast } from '../../context/ToastContext';
import { FiX, FiCheck, FiAlertTriangle, FiInfo, FiAlertCircle, FiRotateCcw } from 'react-icons/fi';
import '../../styles/Toast.css';

/**
 * Toast Container Component
 * Renders all active toast notifications
 */
export function ToastContainer() {
  const { toasts, removeToast } = useToast();

  if (toasts.length === 0) return null;

  return (
    <div
      className="toast-container"
      role="region"
      aria-label="Notifications"
      aria-live="polite"
    >
      {toasts.map(toast => (
        <Toast
          key={toast.id}
          toast={toast}
          onClose={() => removeToast(toast.id)}
        />
      ))}
    </div>
  );
}

/**
 * Individual Toast Component
 */
function Toast({ toast, onClose }) {
  const { message, type, showUndo, onUndo } = toast;

  const icons = {
    success: <FiCheck className="toast-icon" />,
    error: <FiAlertCircle className="toast-icon" />,
    warning: <FiAlertTriangle className="toast-icon" />,
    info: <FiInfo className="toast-icon" />
  };

  const handleUndo = () => {
    if (onUndo) {
      onUndo();
    }
    onClose();
  };

  return (
    <div
      className={`toast-item toast-${type}`}
      role="alert"
      aria-live={type === 'error' ? 'assertive' : 'polite'}
    >
      <div className="toast-content">
        {icons[type]}
        <span className="toast-message">{message}</span>
      </div>
      <div className="toast-actions">
        {showUndo && onUndo && (
          <button
            className="toast-undo-btn"
            onClick={handleUndo}
            aria-label="Undo action"
          >
            <FiRotateCcw />
            Undo
          </button>
        )}
        <button
          className="toast-close-btn"
          onClick={onClose}
          aria-label="Dismiss notification"
        >
          <FiX />
        </button>
      </div>
    </div>
  );
}

export default ToastContainer;
